import { Capacitor, registerPlugin } from "@capacitor/core";

interface NativeSecureStore {
  getToken(): Promise<{ token: string | null }>;
  setToken(options: { token: string }): Promise<void>;
  clearToken(): Promise<void>;
}

const nativeStore = registerPlugin<NativeSecureStore>("MBSecureStore");

function requireNative(): void {
  if (!Capacitor.isNativePlatform()) {
    throw new Error("Secure session storage is available only in the mobile app");
  }
}

/** Read the device-bound session token; null means this app has not signed in. */
export async function readMobileToken(): Promise<string | null> {
  requireNative();
  const result = await nativeStore.getToken();
  return result.token ?? null;
}

/** Persist the session token in Keychain or Android Keystore-backed storage. */
export async function writeMobileToken(token: string): Promise<void> {
  requireNative();
  if (!token) throw new Error("A session token is required");
  await nativeStore.setToken({ token });
}

/** Remove the session token on logout. */
export async function clearMobileToken(): Promise<void> {
  requireNative();
  await nativeStore.clearToken();
}
